import jalaali from "jalaali-js";

export function timeAgo(datetimeString) {
    const now = new Date();
    const past = new Date(datetimeString);
    const diffInSeconds = Math.floor((now - past) / 1000);

    const units = [
        {name: 'ثانیه', value: 60}, // seconds
        {name: 'دقیقه', value: 60}, // minutes
        {name: 'ساعت', value: 24}, // hours
        {name: 'روز', value: 30}, // days
        {name: 'ماه', value: 12}, // months
        {name: 'سال', value: Infinity}, // years
    ];

    let unitIndex = 0;
    let time = diffInSeconds;

    while (time >= units[unitIndex].value && unitIndex < units.length - 1) {
        time = Math.floor(time / units[unitIndex].value);
        unitIndex++;
    }

    const unitName = units[unitIndex].name;

    return `${time} ${unitName} پیش`;
}

export function toJalali(datetime: Date | string): string {
    if (typeof datetime === 'string') {
        datetime = new Date(datetime);
    }
    const jalaliDate = jalaali.toJalaali(datetime.getFullYear(), datetime.getMonth() + 1, datetime.getDate());
    return new Date(jalaliDate.jy, jalaliDate.jm - 1, jalaliDate.jd, datetime.getHours(), datetime.getMinutes(), datetime.getSeconds());
}

// example argument: 2024-10-20T13:48:42.567368Z
export function parseDateToIDay(dateStr) {
    const date = new Date(dateStr);

    return {
        year: date.getUTCFullYear(),
        month: date.getUTCMonth() + 1, // Months are 0-indexed, so we add 1
        day: date.getUTCDate(),
        fullDay: dateStr.slice(0, 10), // YYYY-MM-DD
        hour: date.getUTCHours(),
        minute: date.getUTCMinutes()
    };
}

export function parseIDayToDateStr(IDayObject) {
    const {year, month, day, hour = 0, minute = 0} = IDayObject;

    // Ensure two-digit format for month, day, hour, and minute
    const monthStr = String(month).padStart(2, '0');
    const dayStr = String(day).padStart(2, '0');
    const hourStr = String(hour).padStart(2, '0');
    const minuteStr = String(minute).padStart(2, '0');

    // Construct date string in ISO format
    return `${year}-${monthStr}-${dayStr}T${hourStr}:${minuteStr}:00Z`;
}
export function toEnDigit(s) {
    return s.replace(/[\u0660-\u0669\u06f0-\u06f9]/g,    // Detect all Persian/Arabic Digit in range of their Unicode with a global RegEx character set
        function(a) { return a.charCodeAt(0) & 0xf }     // Remove the Unicode base(2) range that not match
    )
}